module.exports = __webpack_public_path__ + "images/services/fogbugz-preview-logo.fdb17d5813155d5dfafa.svg";